import React from "react";
import { Lock, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
const freeSlots = [{
  name: "MOMENTUM BREAKOUT",
  badge: "LONG ONLY",
  description: "Capture sustained directional moves with defined risk parameters and automated trailing stops."
}, {
  name: "MEAN REVERSION",
  badge: "YOU CHOOSE",
  description: "Identify overextended market conditions for calculated counter-trend opportunities."
}];
export default function StrategicUpdates() {
  return <section id="strategic-updates" className="dark bg-background text-foreground py-24 px-6 md:px-12">
      <div className="max-w-5xl mx-auto flex flex-col gap-16">
        
        {}
        <div className="flex flex-col gap-6">
          {freeSlots.map((slot, i) => <Card key={i} data-index={i} className="rounded-none border-0 border-l-2 border-primary bg-card p-6 md:p-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-6 shadow-none">
              <div className="flex flex-col gap-3 max-w-2xl">
                <span className="font-sans text-xs font-bold tracking-[0.2em] text-primary uppercase">
                  Free Slot
                </span>
                <h3 className="font-sans text-2xl md:text-3xl font-bold text-foreground uppercase tracking-wide">
                  {slot.name}
                </h3>
                <p className="font-serif text-muted-foreground text-lg md:text-xl leading-relaxed">
                  {slot.description}
                </p>
              </div>
              <Badge variant="outline" className="rounded-none border-primary text-primary font-sans text-sm px-4 py-1.5 whitespace-nowrap tracking-wider bg-primary/5">
                {slot.badge}
              </Badge>
            </Card>)}
        </div>

        {}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
          {Array.from({
          length: 14
        }).map((_, i) => <div key={i} data-index={i} className="aspect-square border border-foreground bg-card flex items-center justify-center opacity-35 rounded-none transition-opacity duration-300 hover:opacity-50">
              <Lock className="w-6 h-6 text-foreground" strokeWidth={1.5} />
            </div>)}
        </div>

        {}
        <div className="flex justify-center mt-4">
          <Link to="/ThePlannerPage">
            <Button variant="outline" className="rounded-none border-primary text-primary hover:bg-primary hover:text-background font-sans px-8 py-6 text-base tracking-widest uppercase transition-colors duration-300">
              See All Patterns
              <ArrowRight className="ml-3 w-5 h-5" />
            </Button>
          </Link>
        </div>

      </div>
    </section>;
}